import styled from 'styled-components';

export const Clients = styled.div`
  background: white;
  min-height: 100%;
`
